export type LogRegistryLeafNode = Record<string, never>;
export type LogRegistry = {
    [key: string]: LogRegistry | LogRegistryLeafNode;
};

export const LOG_REGISTRY = Object.freeze({
    rcToggler: {},
    utils: {
        auth: {},
        patchMirage: {},
        ensureCrossOriginIsolation: {},
    },
    camera: {
        useHandleCameraMoved: {},
    },
    svgRenderer: {
        wrapper: {},
        lib: {},
    },
    telemetry: {},
    commandChannel: {},
    miniMap: {
        levelsTree: {},
        utils: {},
        miniMapWeb: {},
        tiled: {},
    },
    measure: {
        preloadBrep: {},
        duoMeasurement: {},
        entityPick: {},
        objectToObject: {},
    },
    analytics: {},
    dataAccess: {
        bimIndex: {},
    },
});
